import {POST} from "@/services/gateway";
import {trimString} from "@/components/common/utils/trimString";

const listItems = ({pagination, classroomIds, snapshotDateTime, folderId, searchTerm}) => {
  return POST('google/classroom/people/search', {
    pagination,
    classroomIds,
    snapshotDateTime,
    folderId,
    searchTerm: trimString(searchTerm)
  });
}

const listBreadcrumps = ({classroomId, folderId, snapshotDate}) => {
  return POST('google/classroom/people/breadcrumbs', {classroomId, folderId, snapshotDate})
}

const exportSnapshot = ({snapshotDateTime, sourceIds, searchTerm, selectedIds, outputFormat, code, extension, storageDestinationId, dataType, storageDestinationType}) => {
  return POST('google/classroom/people/export', {
    snapshotDateTime,
    sourceIds,
    searchTerm: trimString(searchTerm),
    selectedIds,
    outputFormat,
    extension, storageDestinationId, dataType, storageDestinationType
  }, {code: code ? code : null})
}

const restoreSnapshot = ({
                           snapshotDateTime,
                           sourceIds,
                           searchTerm,
                           destinationId,
                           selectedIds,
                           RestoreType,
                           code
                         }) => {
  return POST('google/classroom/people/restore', {
    snapshotDateTime,
    sourceIds,
    searchTerm: trimString(searchTerm),
    destinationId,
    selectedIds,
    RestoreType
  }, {code: code ? code : null})
}

export {
  listItems,
  listBreadcrumps,
  exportSnapshot,
  restoreSnapshot,
}
